import {
  Component, OnInit, TemplateRef, ViewChild, ViewContainerRef, ElementRef, ComponentFactoryResolver, ComponentRef, NgModule, OnDestroy, Renderer2,
  effect,
  signal,
  WritableSignal,
} from '@angular/core';

import { AnimationEvent, trigger, state, style, animate, transition } from '@angular/animations';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Subscription, Observable, fromEvent, pipe, from } from 'rxjs';
import { last, map, switchMap, take, filter, first } from 'rxjs/operators';

import { BrowserSnifferService } from '../../services/browser-sniffer.service';
import { MapService } from '../../services/map.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LegendService } from './legend.service';
import { LayerService } from '../../services/layers/layer.service';
import { Layer } from '../../models/layer';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { ToggleEventNameType, ToggleEventService, ToggleEventType, } from '../../services/toggle-event.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BackEventService } from '@tt-lib/services/back-event.service';

@Component({
  selector: 'tt-legend',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatExpansionModule,
    MatTooltipModule,
    TranslateModule
  ],
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss'],
  animations: [
    /** Animation that slides a drawer in and out. */
    /** Bit of a copy from mat-drawer */
    trigger('openClose', [
      state('open', style({
        transform: 'translate3d(0px, 0px, 0px)',
        //'visibility': 'visible',
      })),
      state('close', style({
        'box-shadow': 'none',
        //'visibility': 'hidden',
      })),
      transition('open => close', animate('250ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
      transition('close => open', animate('250ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
    ]),
  ],
  standalone: true
})
export class LegendComponent implements OnInit, OnDestroy {
  @ViewChild('ttLegendDrawer') ttLegendDrawer: TemplateRef<unknown>;
  @ViewChild('legendTemplate') legendTemplate: TemplateRef<unknown>;
  @ViewChild('legendContainer', { read: ViewContainerRef })
  legendContainer: ViewContainerRef;

  private overlayRef: OverlayRef;
  private subscriptions: Subscription = new Subscription();
  private legendSubscription: Subscription;
  private isAnimating: WritableSignal<boolean> = signal(false);
  public isOpen: WritableSignal<boolean> = signal(false);
  private mapElement: HTMLElement;
  private olControlElements; //:NodeList;    //<HTMLElement>[];
  // document.querySelector<HTMLElement>('.ol-viewport')!
  map;

  constructor(
    //public translateService: TranslateService,
    private _elementRef: ElementRef<HTMLElement>,
    public browsersniffer: BrowserSnifferService,
    public mapService: MapService,
    protected sanitizer: DomSanitizer,
    private cfr: ComponentFactoryResolver,
    private toggleEventService: ToggleEventService,
    public legendService: LegendService,
    public layerService: LayerService,
    public dialog: MatDialog,
    private _renderer: Renderer2,
    private backEventService: BackEventService
  ) {
    // react to phone layout
    effect(() => {
      if (this.browsersniffer.isPhone()) {
        if (this.isOpen()) {
          this.close();
        }
      }
    });
  }

  public activeLayerId: string;
  public activeLayerLabel: string;
  public legendLayers: Layer[]; //layers that have legend set in config
  public legendCollection: object; //legendcomponents that are set

  ngOnInit(): void {
    // this.subscriptions.add(
    //   this.browsersniffer.subscribeToLayoutChanges().subscribe(() => {
    //     if (this.browsersniffer.isPhone()) {
    //       if (this.isOpen()) {
    //         this.close();
    //       }
    //       document.querySelector<HTMLElement>(
    //         '.legend-button-container'
    //       ).style.display = 'none';
    //     } else {
    //       document.querySelector<HTMLElement>(
    //         '.legend-button-container'
    //       ).style.display = '';
    //     }
    //   })
    // );

    this.subscriptions.add(
      this.toggleEventService.emitter$.subscribe(
        (toggleEvent: ToggleEventType) => {
          switch (toggleEvent.forwardedFor) {
            case 'trace':
            case 'legend': {
              if (toggleEvent.eventName === (toggleEvent.forwardedFor === 'trace' ? ToggleEventNameType.OPEN : ToggleEventNameType.CLOSE_COMMAND)) {
                if (this.isOpen) {
                  this.close();
                }
              }
              break;
            }
          }
        }
      )
    );
    this.map = this.mapService.getMap();
    this.mapElement = document.getElementById('map');
    this.olControlElements = document.querySelectorAll<HTMLElement>(
      'tt-zoom, .elevation-profile-button-container, .baselayer-selector-button-container, .legend-button-container, .trace-select-button-container, .remarks-select-button-container, .measure-button-container, .ol-scale-line, tt-mouse-position,  tt-mouse-position-mapindex'
    );
    this.initLegendComponents();

    setTimeout(() => {
      // this.toggle();
      // this.openDialog()
    }, 750);
  }

  toggle() {
    this.isOpen() ? this.close() : this.open();
  }

  close() {
    // this.subscriptions.unsubscribe();
    if (this.legendSubscription) {
      this.legendSubscription.unsubscribe();
    }
    this.olControlElements.forEach((elm) => {
      <HTMLElement>elm.classList.remove('rightbar-open');
    });
    this.mapElement.style.width = '';
    this._renderer.removeClass(this.mapElement, 'legend-open')

    this.isOpen.set(false);
    // for centering on map when legend is open remove class for cdk
    document
      .getElementsByTagName('body')[0]
      .classList.remove('legend-drawer-open');

    this.toggleEventService.toggleEvent({
      eventName: ToggleEventNameType.CLOSE,
      forwardedFor: 'legend',
    });
  }

  open() {
    this.setLegendAndSubscription();
    this.mapElement.style.width = 'calc(100% - 260px)';
    this._renderer.addClass(this.mapElement, 'legend-open');
    this.olControlElements.forEach((elm) => {
      <HTMLElement>elm.classList.add('rightbar-open');
    });
    this.isOpen.set(true);
    // for centering on map when legend is open remove class for cdk
    document
      .getElementsByTagName('body')[0]
      .classList.add('legend-drawer-open');

    this.toggleEventService.toggleEvent({
      eventName: ToggleEventNameType.OPEN,
      forwardedFor: 'legend',
    });

    //toggleEventService is listening for legend/CLOSE_COMMAND above
    this.backEventService.registerOpenedWindow({windowName: 'legend', isAutoCloseableWindow: false});
  }

  initLegendComponents() {
    //this.subscriptions.add(this.legendService.getLegendLayers().subscribe(layers => this.legendLayers = layers));
    this.legendCollection = this.legendService.getlegendCollection();
  }

  setLegendAndSubscription() {
    this.activeLayerId = this.layerService.getActiveBaselayerId();
    // let legendId = this.getLegendId();
    let legendId = this.legendService.getLegendId(this.activeLayerId);
    this.setLegend(legendId);
    this.setActiveLayerLabel(this.activeLayerId);
    this.setActiveLayerLabelAndLegendSubscription();
  }

  // getLegendId(): string {
  //   return (this.legendLayers.map(layer => layer.id).includes(this.activeLayerId)) ? this.legendCollection[this.activeLayerId] ? this.activeLayerId : 'nolegend' : 'nolegend';
  // }

  setActiveLayerLabel(layerId: string) {
    this.layerService
      .findAvailableBusinessLayerById(layerId)
      .subscribe((layer) => (this.activeLayerLabel = layer.label));
  }

  setActiveLayerLabelAndLegendSubscription() {
    this.subscriptions.add(
      (this.legendSubscription = this.layerService
        .getActiveBaselayerId$()
        .pipe(
          map((layerId) => {
            this.setActiveLayerLabel(layerId);
            return this.legendService.legendLayers
              .map((layer) => layer.id)
              .includes(layerId)
              ? layerId
              : 'nolegend'; // has selected layer a legend
          }),
          map((layerId) => {
            return this.legendCollection[layerId] ? layerId : 'nolegend'; // is legendcomp defined in collection
          })
        )
        .subscribe((layerId) => this.setLegend(layerId)))
    );
  }

  setLegend(layerId) {
    this.toggleVisibility(layerId); // to keep status of legend container (scroll/accordian) componentst are set visible/invisible
    if (!this.legendCollection[layerId].legendComponentRef) {
      // first time component has to be loaded in template
      this.loadComponent(layerId);
    }
  }

  toggleVisibility(layerId) {
    for (let key in this.legendCollection) {
      if (this.legendCollection[key].legendComponentRef) {
        if (key === layerId) {
          this.legendCollection[key].legendComponentRef.instance.active = true;
        } else if (this.legendCollection[key].legendComponentRef) {
          this.legendCollection[key].legendComponentRef.instance.active = false;
        }
      }
    }
  }

  async loadComponent(layerId) {
    let legendItem = this.legendCollection[layerId];
    let legendFactory = this.cfr.resolveComponentFactory(
      legendItem.componentClass
    );
    legendItem.legendComponentRef = <Component>(
      this.legendContainer.createComponent(legendFactory)
    ); //, null, this.injector
    legendItem.legendComponentRef.instance.active = true;
  }

  // public openDialog(): void {
  //   if (this.legendCollection) { this.initLegendComponents(); };
  //   this.activeLayerId = this.layerService.getActiveBaselayerId();
  //   this.setActiveLayerLabel(this.activeLayerId);
  //   const dialogRef = this.dialog.open(LegendDialogComponent, {
  //     width: '900%',
  //     data: {
  //       activeLayerLabel: this.activeLayerLabel,
  //       activeLayerId: this.activeLayerId,
  //       legendItem: this.legendCollection[this.getLegendId()]
  //     }
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed');
  //   });
  // }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  ngAfterViewInit() {
    // setTimeout(()=> this.toggle(),500);
    this.olControlElements = document.querySelectorAll<HTMLElement>(
      'tt-zoom, .elevation-profile-button-container, .baselayer-selector-button-container, .legend-button-container, .trace-select-button-container, .remarks-select-button-container, .measure-button-container, .ol-scale-line, tt-mouse-position,  tt-mouse-position-mapindex'
    );
  }

  onAnimationEventStart(event: AnimationEvent) {
    this.isAnimating.set(true);
  }

  onAnimationEventEnd(event: AnimationEvent) {
    this.isAnimating.set(false);
    // if (event.fromState === 'open' && event.phaseName === 'done') {
    //    this.overlayRef.detach();
    // }
  }
}
